import ViewportValues from './viewport/ViewportValues'
const viewportValues = new ViewportValues()
class ScrollHandler {
  constructor () {
    this.lastPos = -1
    this._position = {}
    this._onScroll = []
    this.run()
  }

  get position () {
    return this._position
  }

  set position (pos) {
    this._position = {
      top: pos,
      bottom: pos + viewportValues.height
    }
  }

  onScroll (fn) {
    this._onScroll.push(fn)
  }

  removeFn (fnToRemove) {
    this._onScroll = this._onScroll.filter((fn) => {
      return fn !== fnToRemove
    })
  }

  cb () {
    for (var i = 0; i < this._onScroll.length; i++) {
      this._onScroll[i](this.position)
    }
  }

  run () {
    requestAnimationFrame(() => {
      this.position = window.pageYOffset
      if (this.lastPos === this._position.top) {
        this.run()
        return
      }
      this.lastPos = this._position.top
      this.cb()
      this.run()
    })
  }
}

let instance = new ScrollHandler()
export default class Singleton {
  constructor () {
    return instance
  }
}



// WEBPACK FOOTER //
// ./src/utils/ScrollHandler.js